<template>
    <div>
        <div class="row">
            <div class="row-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>map-marker-outline</title>
                    <path d="M12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5M12,2A7,7 0 0,1 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9A5,5 0 0,0 12,4Z" />
                </svg>
            </div>
            <div class="row-content">
                    <div class="row__title">Shipping Location</div>
                    <div class="pseudoloader" size="40"></div>
                    <div class="pseudoloader" size="100"></div>
            </div>
        </div>
        <div class="row">
            <div class="row-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>truck-fast-outline</title>
                    <path d="M.75 7.5H10.5L11.25 9H1.5L.75 7.5M1.75 10.5H11.5L12.25 12H2.5L1.75 10.5M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M8 18.5C8.83 18.5 9.5 17.83 9.5 17C9.5 16.17 8.83 15.5 8 15.5C7.17 15.5 6.5 16.17 6.5 17C6.5 17.83 7.17 18.5 8 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H11C11 18.66 9.65 20 8 20C6.34 20 5 18.66 5 17H3V13.5 13.5H5V15H5.76C6.31 14.39 7.11 14 8 14C8.89 14 9.69 14.39 10.24 15H15V6H3V6C3 4.89 3.89 4 5 4H17V8H20Z" />
                </svg>
            </div>
            <div class="row-content">
                <div class="row__title">Delivery</div>
                <div class="pseudoloader" size="100"></div>
            </div>
        </div>
        <div class="row">
            <div class="row-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>credit-card-check-outline</title>
                    <path d="M13 19C13 18.66 13.04 18.33 13.09 18H3V12H19V13C19.7 13 20.37 13.13 21 13.35V6C21 4.89 20.11 4 19 4H3C1.89 4 1 4.89 1 6V18C1 19.1 1.89 20 3 20H13.09C13.04 19.67 13 19.34 13 19M3 6H19V8H3V6M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22" />
                </svg>
            </div>
            <div class="row-content">
                <div class="row__title">Payment</div>
                <div class="pseudoloader" size="70"></div>
                <div class="pseudoloader" size="100"></div>
            </div>
        </div>
        <div>
            <table class="pricing-table">
                <tr>
                    <td>
                        Subtotal
                    </td>
                    <td>
                        <div class="pseudoloader" size="40"></div>
                    </td>
                </tr>
                <tr>
                    <td>Sales Tax</td>
                    <td>
                        <div class="pseudoloader" size="40"></div>
                    </td>
                </tr>
                <tr>
                    <td>
                        Shipping
                    </td>
                    <td>
                        <div class="pseudoloader" size="40"></div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Grand Total</b>
                    </td>
                    <td>
                        <div class="pseudoloader" size="40"></div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        }
    }
</script>

<style lang="scss" scoped>
.pricing-table {
    color: #7C7C7C;
    font-weight: lighter;
    font-size: 0.8em;
    margin: 1em 0 1em 80px;
    min-width: 250px;
    td {
        width: 50%;
    }
}

b {
    color: #202020;
}

.row {
    color: #7C7C7C;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #e3e6ec;
    padding: 1rem 0;
    &__title {
        font-weight: 600;
        font-size: .825rem;
        margin-bottom: 0.25em;
        @media screen and (max-height:600px) {
            display: none;
        }
    }
}

.row .row-icon {
    text-align: center;
    width: 80px;
}

.row-content {
    flex-grow: 1;
    padding-right: 1em;
}

.row .row-icon svg {
    width: 1.8em !important;
    height: auto !important;
    opacity: 0.7;
}

.address-line {
    font-size: 0.8em;
    font-weight: lighter;
}

.pseudoloader {
  border-radius: 50px;
  height: .5rem;
  width: 100%;
  background-position: 0 0;
  margin-bottom: .5rem;
  overflow: hidden; 
  position: relative;
}

.pseudoloader::before {
  content:'';
  width: 200%;
  height: 100%;
  position: absolute;
  left: -100%;
  top: 0;
  background: linear-gradient(to right, #efefef, #dcdcdc, #efefef);
  background-size: 50% 100%;
  animation: load 1s infinite linear;
}

.pseudoloader[size="70"] {
  width: 70%;
}

.pseudoloader[size="40"] {
  width: 40%;
}

@keyframes load {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(50%);
  }
}
</style>